import { join } from "path";
export const BASE = window.initialProps?.BASE_PATH || "/";

export function path(url) {
  return join(BASE, url);
}

export const COMPONENTS = path("components");
export const NOT_FOUND = path("*");
export const UNAUTHORIZED = "b2b.unauthorized";
export const IMAGES = {
  noImage: () => path("/images/ph_image.svg")
};

export const PREHLED = "b2b.prehled";

export const ADMINISTRACE = {
  BASE: "b2b.administrace",
  KONFIGURACNI_PARAMETRY: "b2b.administrace.konfiguracni-parametry",
  ZAKAZNIK: "b2b.administrace.zakaznik",
  ZAKAZNIK_SMLOUVA: "b2b.administrace.zakaznik.smluva",
  ZAKAZNIK_PROJEKT: "b2b.administrace.zakaznik.projekt",
  ZAKAZNICI: "b2b.administrace.zakaznici",
  ZDROJE: "b2b.administrace.zdroje",
  ZDROJ: "b2b.administrace.zdroj",
  PRODUKT: "b2b.administrace.produkt",
  DOPLNKOVA_SLUZBA: "b2b.administrace.doplnkova-sluzba"
};

export const REZERVACE = {
  BASE: "b2b.rezervace",
  HISTORIE: "b2b.rezervace.historie",
  ODBAVENI: "b2b.rezervace.odbaveni",
  VYTVORENI: "b2b.rezervace.vytvoreni",
  CASOVY_PLAN: "b2b.rezervace.casovy-plan"
};

export const PROVOZNI_INFORMACE = {
  LIST: "b2b.provozni-informace.list",
  DETAIL: "b2b.provozni-informace.detail",
  VYTVORENI: "b2b.provozni-informace.new",
  EDITACE: "b2b.provozni-informace.edit"
};

export const ZADOSTI = {
  DETAIL: "b2b.zadosti.detail"
};
